import { toaster, Message } from 'rsuite';
import { Check_login_ticket, getToken } from './helper';

export var MyBin = [];
export const initialState = { trashcan: new Set() };
export var trashcan = initialState;

// Utility to generate headers for API requests, with optional charset
function getHeaders(contentType = 'application/json', charset = null) {
    return {
        'Semabench-Token': getToken(),
        'Content-Type': charset ? `${contentType}; charset=${charset}` : contentType
    };
}

// Utility for showing messages with toaster
const showMessage = (message, type = "info") => {
    toaster.clear();
    toaster.push(<Message type={type} showIcon closable>{message}</Message>);
};

// Clears the trashcan by making a DELETE request
export async function cleanTrashcan() {
    try {
        const response = await fetch("../../api/v1/user/trashcan/delete", { headers: getHeaders() });
        if (response.status === 401) {
            Check_login_ticket();
            return;
        }
        const result = await response.json();
        if (result.length > 0) deleteNodes(result);
    } catch (error) {
        console.error("Failed to clean trashcan:", error);
    }
}

// Loads items into MyBin
export async function loadTrashcan() {
    try {
        const response = await fetch("../../api/v1/user/trashcan", { headers: getHeaders() });
        if (response.status === 401) {
            await Check_login_ticket();
            return [];
        }
        MyBin = await response.json();
        return MyBin;
    } catch (error) {
        console.error("Failed to load trashcan:", error);
        return [];
    }
}

export async function loadDisplayTrashcan() {
    try {
        const response = await fetch("../../api/v1/user/bin", { headers: getHeaders() });
        if (response.status === 401) {
            await Check_login_ticket();
            return [];
        }
        return response.json();
    } catch (error) {
        console.error("Failed to load trashcan:", error);
        return [];
    }
}

// Adds items to MyBin and updates the backend
export async function updateTrashcan(trashItems) {
    if (trashItems === undefined || trashItems === null) {
        return await loadTrashcan();
    }

    const items = Array.isArray(trashItems) ? trashItems : [trashItems];
    if (items.length === 0) {
        return MyBin;
    }

    MyBin = [...new Set([...MyBin, ...items])];
    try {
        await fetch("../../api/v1/user/trashcan", {
            headers: getHeaders(),
            method: "POST",
            body: JSON.stringify(items)
        });
    } catch (error) {
        console.error("Failed to update trashcan:", error);
    }
    return MyBin;
}

// Restores items from MyBin to the gallery
export async function restoreTrashcan(nodes) {
    MyBin = [...MyBin.filter(id => !nodes.includes(id))]
    try {
        showMessage("Restoring Items...", "info");
        const response = await fetch("../api/v1/user/trashcan", {
            method: 'DELETE',
            headers: getHeaders(),
            body: JSON.stringify(nodes)
        });

        if (response.ok) {
            showMessage(nodes.length > 1 ? "All Items Restored" : "Item Restored", "success");
        }
    } catch (error) {
        console.error("Failed to restore items:", error);
    } finally {
        toaster.clear();
    }
}

// Deletes specified nodes from MyBin and backend, with charset set to utf-8
export async function deleteNodes(nodes) {
    MyBin = [...MyBin.filter(id => !nodes.includes(id))]
    try {
        const payload = { nodes: nodes.map(node => ({ id: node, storeRef: { protocol: "workspace", identifier: "SpacesStore" } })) };
        const response = await fetch("../api/v1/repo/s/semabench/items", {
            method: 'DELETE',
            headers: getHeaders('application/json', 'utf-8'),
            body: JSON.stringify(payload)
        });
        if (!response.ok) {
            const deletionError = new Error('Failed to delete nodes');
            deletionError.failedItems = nodes;
            throw deletionError;
        }
    } catch (error) {
        const deletionError = new Error('Failed to delete nodes');
        deletionError.failedItems = nodes;
        throw deletionError;
    } finally {
        toaster.clear();
    }
}

// Deletes a single node with default charset
export async function deleteNode(node) {
    try {
        showMessage("Deleting Item...", "info");
        const payload = { nodes: [{ id: node, storeRef: { protocol: "workspace", identifier: "SpacesStore" } }] };
        const response = await fetch("../api/v1/repo/s/semabench/items", {
            method: 'DELETE',
            headers: getHeaders(),
            body: JSON.stringify(payload)
        });

        if (response.ok) {
            showMessage("Item Deleted", "success");
        }
    } catch (error) {
        console.error("Failed to delete item:", error);
    } finally {
        toaster.clear();
    }
}
